import React from 'react';
import propTypes from 'prop-types';
import {EmailShareButton, EmailIcon, FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon} from "react-share";
import styled from '@emotion/styled';
import { theme } from '../../../themes/default-theme';
import Topo from '../../../assets/topo-block-blue.png';

const CaptionContainer = styled.div`
  width: 650px;
  height: 260px;
  background: white;
  margin: 0 auto;
  position: relative;
  max-width: 100%;

  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform:translate(-50%, -50%);
  }

  &:before {
    content: '';
    background: url(${Topo});
    background-size: cover;
    width: 95px;
    height: 100%;
    display: block;
  }
`
const ShareHeading = styled.div`
  font-size: 14px;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
  color: ${theme.palette.charcoal};
  letter-spacing: 1.4px;
`

const Email = styled(EmailIcon)`
  border-radius: 80px;
  
  & rect {
    fill: ${theme.palette.vividBlue};
  }
`

const Facebook = styled(FacebookIcon)`
  border-radius: 80px;

  & rect {
    fill: ${theme.palette.vividBlue};
  }
`

const Twitter = styled(TwitterIcon)`
  border-radius: 80px;

  & rect {
    fill: ${theme.palette.vividBlue};
  }
`

const SharePopup = (props) => {
    return (
        <CaptionContainer>
            <div>
                <ShareHeading>Share this page on:</ShareHeading>
                <span onClick={() => props.onShareClick('Email')}>
                <EmailShareButton url={global.location}>
                    <Email size={38}/>
                </EmailShareButton>
                </span>
                <FacebookShareButton url={global.location} onClick={() => props.onShareClick('Facebook')}>
                    <Facebook size={38} />
                </FacebookShareButton>
                <TwitterShareButton url={global.location} onClick={() => props.onShareClick('Twitter')}>
                    <Twitter size={38} />
                </TwitterShareButton>
            </div>
        </CaptionContainer>
    )
}

SharePopup.propTypes = {
}

export default SharePopup